module.exports = __webpack_public_path__ + "static/media/Bills_Company_Placeholder.c0f23514.svg";